import { render } from "./BankAccount.vue?vue&type=template&id=491e914c&ts=true"
import script from "./BankAccount.vue?vue&type=script&lang=ts"
export * from "./BankAccount.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__